import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "format-highlight-text",
  "use": "format-highlight-text-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"format-highlight-text\"><path fill-rule=\"evenodd\" d=\"M0 20h24v4H0v-4Zm5.224-8.036 1.113 1.112L3 16.413h4.449L8.561 15.3l1.112 1.112 4.45-4.45-4.45-4.448-4.449 4.449Zm9.225-9.225a1.108 1.108 0 0 1 1.57 0l2.88 2.878a1.115 1.115 0 0 1 0 1.571l-3.664 3.664-4.45-4.45L14.45 2.74Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol